import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SimpleFlexbox, Text, Picture } from 'ctm-components';
import { FormLoading } from './form_loading';
import { FormElements } from './form_elements';
import styles from './shielded.css';

class FormContainer extends PureComponent {

    /**
     * Handles whether to show loading or form
     * @returns {Node} returns the current element to display
     */
    handleLoading = () => {
        const { loading, ...restProps } = this.props;
        if (loading) return <FormLoading />;
        return <FormElements {...restProps} />;
    };

    render = () => (
        <SimpleFlexbox className={styles.form_root}>
            <Text tagName="h2" className={styles.message_content}>
                No quotes were received from our providers.
            </Text>
            <Text tagName="p" className={styles.message_ptag}>
                This could be because you do not meet their underwriting requirements, or
                perhaps they do not have a suitable product for you based on the information provided.
            </Text>
            <Text tagName="h2" className={styles.message_content}>
                What’s next?
            </Text>
            <Text tagName="p" className={styles.message_ptag}>
                We have partnered with Shielded Insurance Brokers as they have access to a wider range of products and may be able to assist you.
            </Text>
            <SimpleFlexbox display="flex" className={styles.imgBox}>
                <Picture src="/evt/assets/brand/ctm/images/shielded/logo.png" className={styles.logo} />
                <Picture src="/evt/assets/brand/ctm/images/shielded/award.png" className={styles.award} />

            </SimpleFlexbox>
            {this.handleLoading()}
        </SimpleFlexbox>
    );

}

FormContainer.propTypes = {
    loading: PropTypes.bool.isRequired
};

export { FormContainer };
